import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class Mapmy extends Component {
    render() {
        return (
            <div>
                {/* Header */}
                <Header />

                {/* Banner */}
                <Banner title="Digital Library" image="banner/library-3.jpg" />

                {/* Content */}
                <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area order-lg-2">
                                <div className="ttm-service-single-content-area">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">Knimbus</h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5" style={{ margin: "auto" }}>
                                                <div className="ttm_single_image-wrapper">
                                                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/digital/MapMy.jpg"} alt="single-img-eighteen" />
                                                </div>
                                            </div>
                                            <div className="col-md-7" style={{ margin: "auto" }}>
                                                <p className="justify">The Remote Access Gateway has been specially designed by the library for the academic community of VTU Consortium, Belagavi to provide off-campus and anytime-anywhere access to the library's digital resources for seamless teaching, learning and research. By leveraging secure cloud hosting services, the academic community is privileged to have seamless access to library digital resources from any device.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ttm-service-single-content-area paddingtop-2">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">Links</h4>
                                        </div>
                                    </div>
                                    <table class="table">
                                        <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                                            <tr>
                                                <th scope="col">SL No</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">URL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>01</td>
                                                <td>Knimbus</td>
                                                <td><a href="https://bitb.knimbus.com/" target="_blank">Click Here</a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <DigitalSidebar />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <Footer />
            </div>
        )
    }
}
